import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { Table, Icon, Spin } from 'antd';
import { TitleText, BasicText, ShortInput, LongInput, CopyUrl, BasicButton } from '@components';
import { ConfirmModal } from '@components';
import { deleteUser } from '@actions';

const DeleteButton = ({
  user,
  deleteUser,
  onDeleted
}) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const deleteUserConfirmed = () => {
    setIsLoading(true);
    console.log("blocking", user.full_name);
    deleteUser(user.id, () => {
      setIsLoading(false);
      setShowDeleteConfirm(false);
    }, () => setIsLoading(false));

  };

  const button = () => {
    return (
      <BasicButton
        text="Delete"
        type="danger"
        fontSize={10}
        style={{ padding: 8 }}
        onClick={() => setShowDeleteConfirm(true)}
      />
    );
  }

  return (
    <>
      {button()}

      {showDeleteConfirm &&
        <ConfirmModal
          title={"Confirm Block User"}
          visible={showDeleteConfirm}
          loading={isLoading}
          onCancel={() => setShowDeleteConfirm(false)}
          onSubmit={() => deleteUserConfirmed()}
        >
          <BasicText marginBottom="20px">
            Are you sure you want to delete the user {user.full_name}?
          </BasicText>
        </ConfirmModal>
      }
    </>
  );
};

export default connect(null, {
  deleteUser
})(DeleteButton);
